// accessibility tests
export const ACCESSIBILITY_TEXTS = {
    GO_BACK: "Go Back",
};
